import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ME_Fit } from 'me-fit-typings';
import { Feedback } from 'src/app/decorators/feedback-decorator';
import { CustomersStateService } from 'src/app/state/customers.state.service';
import { InlineSearchFunction, InlineSearchItem } from '../../components/inline-search/inline-search.component';
import { SearchService } from 'src/app/services/search.service';
import { FeatureFlipService } from 'src/app/services/feature-flip.service';
import { phoneNumberValidatorPattern } from 'src/app/utils/phone-number-pattern';

interface CreateFormValue {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  organizationGroups: ME_Fit.OrganizationGroup[];
}


@Component({
  selector: 'app-customer-create-modal',
  templateUrl: './customer-create-modal.component.html',
  styleUrls: ['./customer-create-modal.component.css']
})
export class CustomerCreateModalComponent implements OnInit {

  customerCreateForm = this.fb.group({
    firstName: [null, Validators.required],
    lastName: [null, Validators.required],
    email: [null, [Validators.email]],
    phoneNumber: [null, [Validators.pattern(phoneNumberValidatorPattern)]],
    organizationGroups: [[]],
  });

  groupSearchFn: InlineSearchFunction = this.$search.searchGroups;

  public get selectedGroupsForCreateCustomer() {
    return this.customerCreateForm.get('organizationGroups')!.value ?? [];
  }

  whatsappInviteFlowEnabled$ = this.$featureFlip.isFeatureEnabled('whatsappInviteFlow');

  constructor(
    private modalCtrl: ModalController,
    private fb: UntypedFormBuilder,
    private $customerState: CustomersStateService,
    private $search: SearchService,
    private $featureFlip: FeatureFlipService
  ) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  onAddCustomerFormSubmit() {
    if (this.customerCreateForm.invalid) {
      return;
    }

    this.addCustomer(this.customerCreateForm.value);
  }

  @Feedback({
    i18nFailKey: 'customer.add.fail',
    i18nSuccessKey: 'customer.add.success',
    i18nLoadingMessage: 'customer.add.loading'
  })
  async addCustomer(customerCreateFormValue: CreateFormValue) {
    let promise: Promise<ME_Fit.OrganizationCustomer>;

    try {
      const { firstName, lastName, email, phoneNumber, organizationGroups } = customerCreateFormValue;

      promise = this.$customerState.create.call({
        request: {
          firstName,
          lastName,
          email,
          phoneNumber,
          organizationGroupIds: organizationGroups.map(group => group.id),
          notes: []
        }
      });

      const customer = await promise;


      this.modalCtrl.dismiss(customer);
    } catch (error) {
      console.error('[CustomerCreateModalComponent:addCustomer] error', error);
    }

    return promise!;
  }

  createCustomerGroupSelected(event: InlineSearchItem<ME_Fit.OrganizationGroup>) {
    console.log('createCustomerGroupSelected', event);

    const groupsCtrl = this.customerCreateForm.get('organizationGroups')!;
    groupsCtrl.setValue(
      [...groupsCtrl.value, event.rawObject]
    );
  }

  createCustomerGroupRemoved(groupId: string) {
    const groupsCtrl = this.customerCreateForm.get('organizationGroups')!;
    groupsCtrl.setValue(
      groupsCtrl.value.filter(group => group.id !== groupId)
    );
  }


}
